import React from 'react';
import { Table } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const WaterTowersTable = ({ activeLane }) => {
  // Get data from Redux store
  const data = useSelector(state => state.waterTowers?.data || []);
  const isLoading = useSelector(state => state.waterTowers?.loading || false);

  const filteredData = activeLane === 'ALL' ? data : data.filter(item => item.lane === activeLane);

  if (isLoading) {
    return <div className="text-center p-4">Loading...</div>;
  }

  if (!data || data.length === 0) {
    return <div className="text-center p-4">No data available</div>;
  }

  return (
    <div className="table-responsive">
      <Table className="table">
        <thead>
          <tr>
            <th>Asset Number</th>
            <th>Name</th>
            <th>Capacity</th>
            <th>Cell Number</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map(waterTower => (
            <tr key={waterTower.id}>
              <td>{waterTower.assetNumber || '--'}</td>
              <td>{waterTower.brand || '--'}</td>
              <td>{waterTower.tonnage || '--'}</td>
              <td>{waterTower.cellNumber || '--'}</td>
              <td>
                <span className="badge bg-success">Active</span>
              </td>
              <td>
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => alert('Edit functionality will be implemented here')}
                >
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default WaterTowersTable;
